<template>
  <Row class="page3 overHeight page7">
    <el-dialog
      class="platedialog"
      title="汇率预测"
      style="width: 100vw; height: 100vh; overflow-y: hidden"
      width="100%"
      height="100%"
      top="0"
      :visible.sync="dialogIframe"
    >
      <div style="width: 100%; height: 85vh">
        <iframe
          id="myIframe7"
          src="https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/99801503C65C519FFEB512AEDB81955B?mode=embed"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <Col style="width: 30%">
      <div class="left">
        <div style="height: 100%">
          <div class="left1" style="height: 100%; padding-left: 5%">
            <div style="height: 45%" class="overHeight">
              <!-- <div class="changeItem">
                <div class="item active">按板块</div>
                <div class="item">按公司</div>
              </div> -->
              <!-- <div style="height: 60px"></div> -->

              <div
                class="buPartWrapList"
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  width: 100%;
                "
              >
                <div class="buPartWrap" v-for="item in data1">
                  <div class="buPart" style="position: relative">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="getExpain(item.name)"
                      placement="top-start"
                    >
                      <div
                        class="buPartTitle"
                        style="font-weight: 400; font-size: 1vw"
                      >
                        {{ item.name }}
                      </div>
                    </el-tooltip>

                    <div class="line">
                      <span
                        class="span1"
                        style="font-size: 2vw; font-weight: 700px; color: #fff"
                        >{{ item.value }}</span
                      >
                    </div>
                    <div class="line">
                      <span style="color: #bf9d63; font-size: 0.8vw">环比</span>
                      <span
                        v-if="Number(item.diff.replace('%', '')) > 0"
                        class="span1"
                        style="
                          display: flex;
                          align-items: center;
                          color: #f06161;
                        "
                      >
                        <div class="redTrangle"></div>
                        <div>{{ item.diff }}</div>
                      </span>
                      <span
                        v-else
                        class="span1"
                        style="
                          display: flex;
                          align-items: center;
                          color: #6bbb57;
                        "
                      >
                        <div class="greenTrangle"></div>
                        <div>{{ item.diff.replace("-", "") }}</div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="changeRateWrap" style="min-width: 200px; height: 55%">
              <div class="changeRate overHeight">
                <div class="changeRateTitle">
                  <span class="dot"></span>
                  <span class="word">昨日收盘价/较前一日变化率</span>
                </div>
                <div
                  class="tableList"
                  style="cursor: pointer"
                  @click="openIframe()"
                >
                  <div class="item" v-for="item in data2" :key="item.ticker">
                    <div class="left">{{ item.ticker }}</div>
                    <div class="center">{{ item.exchangeRate }}</div>
                    <div class="right" v-if="item.exchangeRateDif < 0">
                      <span class="dotGreen"></span>
                      <span class="word green">{{
                        item.exchangeRateDif.substring(1)
                      }}</span>
                    </div>
                    <div class="right" v-else>
                      <span class="dotRed"></span>
                      <span class="word red">{{ item.exchangeRateDif }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
    <Col style="width: 70%; padding: 0 1%">
      <div class="overHeight" style="height: 15%">
        <!-- <div style="height: 60px"></div> -->
        <div class="overHeight" style="height: 100%">
          <div class="center-bottom" style="height: 100%">
            <div class="buPart four">
              <Row
                v-if="JSON.stringify(data5).length > 2"
                class="bottom-radars"
                style="
                  padding-left: 15px;
                  padding-right: 15px;
                  display: flex;
                  align-items: center;
                "
              >
                <Col
                  span="9"
                  style="color: #bf9d63; font-size: 1vw"
                  class="flexevenly"
                >
                  <div>EBITDA</div>
                  <div style="margin-top: 10px">汇报期间</div>
                </Col>
                <Col
                  span="5"
                  class="flexevenly"
                  style="padding-left: 1vw; cursor: pointer"
                  @click.native="
                    toEbitda('光明食品亚太有限公司', data5[0]['date'])
                  "
                >
                  <div>
                    <span
                      style="font-size: 1.8vw; color: #fff; font-weight: 700"
                    >
                      {{ data5 && data5[0] && data5[0].value }}
                    </span>
                    <span style="opacity: 0.5; font-size: 1.2vw; color: #fff">
                      ({{ data5 && data5[0] && data5[0].unit }})
                    </span>
                  </div>
                  <div style="font-size: 1.2vw; color: #fff">
                    {{  data5 && data5[0] && data5[0]["date"] }}
                  </div>
                </Col>
                <Col
                  span="5"
                  class="flexevenly"
                  style="padding-left: 1vw"
                  @click.native="toEbitda('意大利SALOV公司', data5[1]['date'])"
                >
                  <div>
                    <span
                      style="
                        cursor: pointer;
                        font-size: 1.8vw;
                        color: #fff;
                        font-weight: 700;
                      "
                    >
                      {{  data5 && data5[1] && data5[1].value }}
                    </span>
                    <span
                      style="
                        cursor: pointer;
                        opacity: 0.5;
                        font-size: 1.2vw;
                        color: #fff;
                      "
                    >
                      ({{ data5 && data5[1] && data5[1]["unit"] }})
                    </span>
                  </div>
                  <div style="font-size: 1.2vw; color: #fff; cursor: pointer">
                    {{ data5 && data5[1] && data5[1]["date"] }}
                  </div>
                </Col>
                <Col
                  span="5"
                  class="flexevenly"
                  style="padding-left: 1vw"
                  @click.native="toEbitda('香港万安公司', data5[2]['date'])"
                >
                  <div>
                    <span
                      style="
                        font-size: 1.8vw;
                        color: #fff;
                        font-weight: 700;
                        cursor: pointer;
                      "
                    >
                      {{ data5 && data5[2] && data5[2].value }}
                    </span>
                    <span
                      style="
                        opacity: 0.5;
                        font-size: 1.2vw;
                        color: #fff;
                        cursor: pointer;
                      "
                    >
                      ( {{ data5 && data5[2] && data5[2].unit }})
                    </span>
                  </div>
                  <div style="font-size: 1.2vw; color: #fff; cursor: pointer">
                    {{ data5 && data5[2] && data5[2]["date"] }}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 2%"></div>
      <div class="changeRateWrap" style="min-width: 300px; height: 83%">
        <div class="changeRate overHeight four" style="padding: 2vw">
          <div class="statusLine">
            <div class="item">
              <div class="dot" style="background: #e16a6a"></div>
              <div class="word">预警未处理</div>
            </div>
            <div class="item">
              <div class="dot" style="background: #e4cc88"></div>
              <div class="word">预警处理中</div>
            </div>
            <div class="item">
              <div class="dot" style="background: #59cf7a"></div>
              <div class="word">正常</div>
            </div>
          </div>
          <div border="1" class="mytable">
            <div class="part1">
              <div
                class="name1 borderBottom borderRight"
                style="height: 42px; line-height: 42px"
              >
                公司名称
              </div>
              <div style="height: 120px" class="borderRight borderBottom"></div>
              <div class="dc">
                <div class="name1 inlineBlock borderRight borderBottom">
                  核心风险
                </div>
                <div class="inlineBlock">
                  <div class="name2 borderRight">食品安全风险</div>
                  <div class="name2 borderTop borderRight">流动性风险</div>
                </div>
              </div>
              <div class="dc">
                <div class="name1 inlineBlock borderRight borderBottom">
                  发展风险
                </div>
                <div class="inlineBlock">
                  <div class="name2 borderTop borderRight">
                    人力资源管理风险
                  </div>
                  <div class="name2 borderTop borderRight">投资管理风险</div>
                  <div class="name2 borderTop borderRight">汇率风险</div>
                  <div class="name2 borderTop borderRight">
                    法律纠纷与诉讼风险
                  </div>
                </div>
              </div>
              <div class="dc">
                <div class="name1 inlineBlock borderRight borderBottom">
                  运营风险
                </div>
                <div class="inlineBlock">
                  <div class="name2 borderTop borderRight">营运资金风险</div>
                  <div class="name2 borderTop borderRight">供应链风险</div>
                  <div class="name2 borderTop borderRight">存货管理风险</div>
                  <div class="name2 borderTop borderRight">
                    应收账款管理风险
                  </div>
                  <div class="name2 borderTop borderRight">原材料采购风险</div>
                </div>
              </div>
              <div class="dc">
                <div class="name1 inlineBlock borderRight borderBottom">
                  廉洁指数
                </div>
                <div class="inlineBlock">
                  <div class="name2 borderTop borderRight borderBottom">
                    廉洁指数
                  </div>
                </div>
              </div>
            </div>
            <div class="part2">
              <div
                @click="toIframe('光明食品亚太有限公司', '食品安全风险')"
                class="name borderTop borderRight borderBottom"
                style="height: 42px; line-height: 42px"
              >
                光明亚太
              </div>
              <div style="height: 120px" class="borderRight">
                <ring
                  :data="data4[0]"
                  v-if="data4 && data4[0] && data4[0].length > 0"
                ></ring>
              </div>
              <!-- <div class="wrap">
                <div class="name borderRight borderBottom"></div>
              </div> -->
              <div class="wrap">
                <div
                  class="name borderRight borderBottom borderTop"
                  @click="toIframe('光明食品亚太有限公司', '食品安全风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '食品安全风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "食品安全风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '流动性风险')"
                >
                  <div
                    :class="getDayDot(1, '光明食品亚太有限公司', '流动性风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "流动性风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '人力资源管理风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '人力资源管理风险')
                    "
                  ></div>
                  <div class="word">
                    {{
                      getDayDot(2, "光明食品亚太有限公司", "人力资源管理风险")
                    }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '投资管理风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '投资管理风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "投资管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '汇率风险')"
                >
                  <div
                    :class="getDayDot(1, '光明食品亚太有限公司', '汇率风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "汇率风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="
                    toIframe('光明食品亚太有限公司', '法律纠纷与诉讼风险')
                  "
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '法律纠纷与诉讼风险')
                    "
                  ></div>
                  <div class="word">
                    {{
                      getDayDot(2, "光明食品亚太有限公司", "法律纠纷与诉讼风险")
                    }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '营运资金风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '营运资金风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "营运资金风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '供应链风险')"
                >
                  <div
                    :class="getDayDot(1, '光明食品亚太有限公司', '供应链风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "供应链风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '存货管理风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '存货管理风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "存货管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '应收账款管理风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '应收账款管理风险')
                    "
                  ></div>
                  <div class="word">
                    {{
                      getDayDot(2, "光明食品亚太有限公司", "应收账款管理风险")
                    }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '原材料采购风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '光明食品亚太有限公司', '原材料采购风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "光明食品亚太有限公司", "原材料采购风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('光明食品亚太有限公司', '廉洁指数')"
                >
                  <!-- <div class="dot1"></div> -->
                  <div class="word">
                    {{ getDayDot(3, "光明亚太廉洁指数", "") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="part2">
              <div
                @click="toIframe('意大利SALOV公司', '食品安全风险')"
                class="name borderTop borderRight borderBottom"
                style="height: 42px; line-height: 42px"
              >
                意大利SALOV公司
              </div>
              <div style="height: 120px" class="borderRight">
                <ring
                  v-if="data4 && data4[2] && data4[2].length > 0"
                  :data="data4[2]"
                ></ring>
              </div>
              <!-- <div class="wrap">
                <div class="name borderRight borderBottom"></div>
              </div> -->
              <div class="wrap">
                <div
                  class="name borderRight borderBottom borderTop"
                  @click="toIframe('意大利SALOV公司', '食品安全风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '食品安全风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "食品安全风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '流动性风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '流动性风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "流动性风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '人力资源管理风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '人力资源管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "人力资源管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '投资管理风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '投资管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "投资管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '汇率风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '汇率风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "汇率风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '法律纠纷与诉讼风险')"
                >
                  <div
                    :class="
                      getDayDot(1, '意大利SALOV公司', '法律纠纷与诉讼风险')
                    "
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "法律纠纷与诉讼风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '营运资金风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '营运资金风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "营运资金风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '供应链风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '供应链风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "供应链风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '存货管理风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '存货管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "存货管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '应收账款管理风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '应收账款管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "应收账款管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '原材料采购风险')"
                >
                  <div
                    :class="getDayDot(1, '意大利SALOV公司', '原材料采购风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "意大利SALOV公司", "原材料采购风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('意大利SALOV公司', '廉洁指数')"
                >
                  <!-- <div class="dot1"></div> -->
                  <div class="word">
                    {{ getDayDot(3, "salov廉洁指数", "") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="part2">
              <div
                @click="toIframe('香港万安公司', '食品安全风险')"
                class="name borderTop borderRight borderBottom"
                style="height: 42px; line-height: 42px"
              >
                香港万安公司
              </div>
              <div style="height: 120px" class="borderRight">
                <ring
                  :data="data4[1]"
                  v-if="data4 && data4[1] && data4[1].length > 0"
                ></ring>
              </div>
              <!-- <div class="wrap">
                <div class="name borderRight borderBottom"></div>
              </div> -->
              <div class="wrap">
                <div
                  class="name borderRight borderBottom borderTop"
                  @click="toIframe('香港万安公司', '食品安全风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '食品安全风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "食品安全风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '流动性风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '流动性风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "流动性风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '人力资源管理风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '人力资源管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "人力资源管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '投资管理风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '投资管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "投资管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '汇率风险')"
                >
                  <div :class="getDayDot(1, '香港万安公司', '汇率风险')"></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "汇率风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '法律纠纷与诉讼风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '法律纠纷与诉讼风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "法律纠纷与诉讼风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '营运资金风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '营运资金风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "营运资金风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '供应链风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '供应链风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "供应链风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '存货管理风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '存货管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "存货管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '应收账款管理风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '应收账款管理风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "应收账款管理风险") }}
                  </div>
                </div>
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '原材料采购风险')"
                >
                  <div
                    :class="getDayDot(1, '香港万安公司', '原材料采购风险')"
                  ></div>
                  <div class="word">
                    {{ getDayDot(2, "香港万安公司", "原材料采购风险") }}
                  </div>
                </div>
              </div>
              <div class="wrap">
                <div
                  class="name borderRight borderBottom"
                  @click="toIframe('香港万安公司', '廉洁指数')"
                >
                  <!-- <div class="dot1"></div> -->
                  <div class="word">
                    {{ getDayDot(3, "万安廉洁指数", "") }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="thr">
              <div class="th">公司名称</div>
              <div class="th">光明亚太</div>
              <div class="th">意大利SALOV公司</div>
              <div class="th">香港万安公司</div>
            </div>
            <div style="height: 200px" class="tr">
              <div rowspan="5" class="td w25"></div>
              <div rowspan="5" class="td w25">
                <ring id="bottom_1_1" :data="data5" ref="chart1"></ring>
              </div>
              <div rowspan="5" class="td w25">
                <ring id="bottom_1_1" :data="data5" ref="chart2"></ring>
              </div>
              <div rowspan="5" class="td w25">
                <ring id="bottom_1_1" :data="data5" ref="chart3"></ring>
              </div>
            </div>
            <div style="height: 150px">
              <div>核心风险</div>
              <div>
                <div>食品安全风险</div>
                <div>流动性风险</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
import {
  getFourPartData,
  jwzxj,
  jwtable,
  jwEchart,
  queryOverSeasEBITDA,
} from "../api/index";
// const chinaMap = () => import("./components/page4/chinaMap");
// const channelBar = () => import("./components/page4/channelBar");
// const distributionSolider = () =>
//   import("./components/page4/distributionSolider");
// const pie = () => import("./components/pie");
// const redPocket = () => import("./components/page4/redPocket");
const ring = () => import("./components/page1/ring4");
// const radar = () => import("./components/radar");
// const doubleBar = () => import("./components/page4/doubleBar");
// const webcastsRisk = ()=> import('./components/page3/webcastsRisk');
// const deviceSafeRisk = ()=> import('./components/page3/deviceSafeRisk');
// const doubleRing = ()=> import('./components/page3/doubleRing');
// const hotWords =() => import('./components/page3/hotWords');
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    // chinaMap,
    // channelBar,
    // distributionSolider,
    // pie,
    // redPocket,
    ring,
    // radar,
    // doubleBar,
    // webcastsRisk,
    // deviceSafeRisk,
    // doubleRing,
    // hotWords
  },
  created() {
    this.getData();
    this.setTitle("集团境外风险概览");
    this.setBackurl("/");
  },
  data() {
    return {
      dialogIframe: false,
      explationList: [
        {
          name: "澳大利亚CPI增长率",
          explain: "CPI环比增长率，即居民消费价格通货膨胀率",
        },
        {
          name: "欧洲CPI增长率",
          explain: "CPI环比增长率，即居民消费价格通货膨胀率",
        },
        { name: "澳储行现金利率", explain: "澳储行隔夜拆借利率" },
        { name: "欧央行主要再融资利率", explain: "商业银行向欧央行融资利率" },
      ],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      resizeFn: null,
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setBackurl"]),
    openIframe() {
      this.dialogIframe = true;
    },
    getDayDot(type, companyName, riskName) {
      if (type == 3) {
        if (
          this.data3[this.data3.length - 1] &&
          this.data3[this.data3.length - 1][companyName]
        ) {
          return this.data3[this.data3.length - 1][companyName] || "-";
        }
      }
      const res = this.data3.find(
        (item) => item.company == companyName && item["风险名称"] == riskName
      );
      if (res) {
        if (type == 1) {
          // 拿dot颜色
          let riskValue = res["总风险值"];
          if (riskValue == 0) {
            // 绿灯
            return "dot3";
          } else if (riskValue > 0 && riskValue < 99) {
            //黄灯
            return "dot2";
          } else if (riskValue >= 99) {
            //红灯
            let day = Number(res['持续天数'].split(' ')[0])
            if(day < 50){
              return "dot1 headerBox big1";
            }else if(day >= 50 && day < 100){
              return "dot1 headerBox big2";
            }else if(day >=100 && day < 150){
              return "dot1 headerBox big3";
            }else if(day >= 150 && day < 200){
              return "dot1 headerBox big4";
            }else if(day >= 200){
              return "dot1 headerBox big5";
            }
            return "dot1 headerBox";
          }
        } else if (type == 2) {
         

          // 拿持续天数
          return res["持续天数"];
        }
      } else {
        return "-";
      }
    },
    async getData() {
      // 左上角四个增长率
      const res = await getFourPartData({ type: 2 });
      if (res.code == 200) {
        this.data1 = res.data;
      }
      //   左下角列表
      const res2 = await jwzxj({ type: 2 });
      if (res2.code == 200) {
        this.data2 = res2.data;
      }
      //   右边table
      const res3 = await jwtable();
      if (res3.code == 200) {
        this.data3 = res3.data;
      }
      //   右边3个echart
      const res4 = await jwEchart();
      if (res4.code == 200) {
        this.data4 = res4.data;
        this.data4 = [this.data4[5], this.data4[1], this.data4[6]];
      }
      //  境外ebita
      const res5 = await queryOverSeasEBITDA();
      if (res5.code == 200) {
        this.data5 = res5.data;
      }
    },
    getExpain(name) {
      let res = this.explationList.find((item) => item.name == name);
      if (res) {
        return res.explain;
      } else {
        return "暂无说明";
      }
    },
    jump(page) {
      this.$router.push(page);
    },
    toEbitda(name, date) {
      //   this.$router.push(`/PC/page/Ebitda/${name}`);
      this.$router.push({
        path: `/PC/page/${name}/EBITDA`,
        query: { date },
      });
    },
    toIframe(key1, key2) {
      this.$router.push({
        path: `/PC/page/${key1}/${key2}`,
      });
    },
  },
  mounted() {
    this.resizeFn = this.$debounce(() => {}, 500);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>
<style lang="less">
.page7 .el-dialog__body {
  padding-left: 0;
  padding-right: 0;
  height: 100%;
}
.el-tooltip__popper.is-dark {
  font-size: 1vw;
  background: #3d4146 !important;
}
/* 更改箭头颜色 */
.el-tooltip__popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #3d4146 !important;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #3d4146 !important;
}
</style>
<style lang="less" scoped>
@keyframes fade {
    from {        
    opacity: 1.0;    
    }
    50% {        
    opacity: 0.4;    
    }
    to {        
    opacity: 1.0;    
    }
}
@-webkit-keyframes fade {    
    from {        
    opacity: 1.0;    
    }
    50% {        
    opacity: 0.4;    
    }
    to {        
    opacity: 1.0;    
    }
}
.headerBox {    
    animation: fade 1200ms infinite;    
    // -webkit-animation: fade 600ms infinite;
}
.big1{
  width:7.5px !important;
  height:7.5px !important;
}
.big2{
  width:10.5px !important;
  height:10.5px !important;
}
.big3{
  width:12.5px !important;
  height:12.5px !important;
}
.big4{
  width:14.5px !important;
  height:14.5px !important;
}
.big5{
  width:15.5px !important;
  height:15.5px !important;
}
.flexevenly {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.buPartWrapList .buPartWrap {
  &:nth-child(1) {
    margin-top: 0 !important;
  }
  &:nth-child(2) {
    margin-top: 0 !important;
  }
}
.bigWord {
  font-size: 20px;
}
.green {
  color: #6bbb57;
}
.red {
  color: #f06161;
}
.borderLeft {
  border-left: solid 1px rgba(255, 255, 255, 0.2);
}
.borderTop {
  border-top: solid 1px rgba(255, 255, 255, 0.2);
}
.borderBottom {
  border-bottom: solid 1px rgba(255, 255, 255, 0.2);
}
.borderRight {
  border-right: solid 1px rgba(255, 255, 255, 0.2);
}
.wrap {
  .name {
    display: flex;
    align-items: center;
    justify-content: center;
    .word {
    }
  }
}
.dot1 {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e16a6a;
}
.dot2 {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e4cc88;
}
.dot3 {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  margin-right: 5px;
  background: #59cf7a;
}
.dc {
  display: flex;
  //   align-items: center;
  width: 100%;
}
.inlineBlock {
  flex: 1;
}
.w25 {
  width: 25%;
}
.mytable {
  width: 100%;
  display: flex;
  .part2 {
    width: 22%;
    .name {
      text-align: center;
      font-size: 0.8vw;
      color: #fff;
      line-height: 1.4vw;
      cursor: pointer;
    }
  }
  .part1 {
    width: 36%;
    background: rgba(87, 87, 87, 0.5);
    text-align: center;
    .name1 {
      font-size: 0.8vw;
      text-align: center;
      line-height: 1.4vw;
      color: #bf9d63;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name2 {
      font-size: 0.8vw;
      line-height: 1.4vw;
      /* identical to box height */
      color: #ffffff;
      opacity: 0.8;
      text-align: center;
      cursor: pointer;
    }
  }
  .thr {
    display: flex;
    align-items: center;
    .th {
      width: 25%;
      color: #fff;
      font-size: 0.8vw;
      text-align: center;
    }
  }
  .tr {
    display: flex;
    align-items:center .td {
      height: 100%;
    }
  }
}
.statusLine {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .item {
    display: flex;
    align-items: center;
    .dot {
      width: 0.5vw;
      height: 0.5vw;
      border-radius: 50%;
      margin-right: 0.2vw;
    }
    .word {
      font-size: 0.8vw;
      color: #fff;
      opacity: 0.8;
      margin-right: 1vw;
    }
  }
}
.four {
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
}
.redTrangle {
  /* 1.首先设置盒子宽高都为0 */
  width: 0;
  height: 0;
  /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
  border: 4px solid transparent;
  /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
  border-top: none;
  /*4.最后设置边框颜色，显示出三角形*/
  border-bottom-color: #f06161;
  margin-right: 3px;
}
.greenTrangle {
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top-color: #6bbb57;
  margin-right: 3px;
}
.center-bottom {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
}
.tableList {
  .item {
    display: flex;
    align-items: center;
    &:nth-child(odd) {
      background: rgba(87, 87, 87, 0.5);
    }
    height: 1.8vw;
    line-height: 1.8vw;
    justify-content: space-between;
    .left {
      font-size: 0.8vw;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 10px;
    }
    .center {
      font-weight: 400;
      font-size: 0.8vw;
      color: #ffffff;
      text-align: center;
    }
    .right {
      text-align: right;
      padding-right: 10px;
      font-weight: 400;
      font-size: 0.8vw;
      color: #f06161;
      .dotRed {
        position: relative;
        bottom: 0.1vw;
        display: inline-block;
        margin-right: 5px;
        width: 0.5vw;
        height: 0.5vw;
        // border-radius: 50%;
        // background: #f06161;
        /* 1.首先设置盒子宽高都为0 */
        width: 0.5vw;
        height: 0.5vw;
        /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
        border: 6px solid transparent;
        /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
        border-top: none;
        /*4.最后设置边框颜色，显示出三角形*/
        border-bottom-color: #f06161;
      }
      .dotGreen {
        position: relative;
        top: 0.1vw;
        display: inline-block;
        // border-radius: 50%;
        // background: #6bbb57;
        width: 0.5vw;
        height: 0.5vw;
        border: 6px solid transparent;
        border-top-color: #6bbb57;
        margin-right: 5px;
      }
    }
    > div {
      width: 33%;
    }
  }
}
.changeRateWrap {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  height: 45%;
  .changeRateTitle {
    display: flex;
    align-items: center;
    .dot {
      display: inline-block;
      border-radius: 50%;
      width: 0.8vw;
      height: 0.8vw;
      background: linear-gradient(
        180deg,
        #bf9d63 0%,
        rgba(217, 217, 217, 0) 100%
      );
    }
    .word {
      padding-left: 10px;
      font-size: 1vw;
      color: #bf9d63;
    }
  }
}
.page3 {
  //   padding-top: 3vw !important;
  .left1 {
    .changeRate {
      padding-left: 3%;
      padding-right: 4%;
      width: 100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
      background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
      padding: 20px;
      .changeRateTitle {
        color: #bf9d63;
        margin-bottom: 3%;
      }
    }
    .buPartWrap {
      cursor: pointer;
      margin-top: 20px;
      display: inline-block;
      width: 48%;
      height: 16vh;
      //   height: 180px;
      //   background: rgba(87, 87, 87, 0.3);
      //   border: 1px solid #4d4a48;
      .buPart {
        width: 100%;
        height: 100%;
        background: linear-gradient(to left, #bf9d63, #bf9d63) left top
            no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
        background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
        padding: 5%;
        .buPartTitle {
          color: #bf9d63;
          font-weight: 600;
          margin-bottom: 5%;
          //   font-size: 20px;
          font-size: 1.5vw;
        }
        .line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .span1 {
            color: #ffffff;
            opacity: 0.6;
            font-size: 20px;
            font-size: 1vw;
          }
          .span2 {
            font-size: 0.5vw;
            color: #ffffff;
            opacity: 0.8;
            font-size: 1.5vw;
          }
        }
      }
      background: rgba(87, 87, 87, 0.3);
      border: 1px solid #4d4a48;
      box-sizing: border-box;
    }
    .changeItem {
      margin-top: 20px;

      .item {
        cursor: pointer;
        display: inline;
        margin-right: 40px;
        min-width: 105px;
        height: 40px;
        color: #bf9d63;
        padding: 8px 14px;
        color: #fff;
        &.active {
          background: #4a3e29;
          border-radius: 60px;
          color: #bf9d63;
        }
      }
    }
  }
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   background: #03044a;
  overflow: hidden;
  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    // background: rgba(87, 87, 87, 0.3);
    // border: 1px solid #4d4a48;
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      //   border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }

    .title {
      position: absolute;
      display: inline-block;
      color: #6eddf1;
      border: 2px solid #6eddf1;
      height: 18px;
      padding: 0 2px;
      left: 50%;
      transform: translate(-50%, -50%);

      .title-text {
        position: relative;
        font-size: 16px;
        background: #09102e;
        display: inline-block;
        padding: 0 4px;
        transform: translateY(-5px);
      }
    }
  }

  .center-top {
    height: 75%;
  }

  .center-bottom {
    height: 25%;

    .bottom-radars {
      height: 100%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
</style>
